import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'antd';
import { CheckOutlined, GlobalOutlined } from '@ant-design/icons';
import { useCountries } from '@/hooks';
import { adminLocalizationApi } from '@/api';
import { queryClient } from '@/app/QueryClientProvider';
import { entitiesActions } from '@/store/entities';
import { useDispatch, useSelector } from 'react-redux';

export const LanguageSelect = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const { changeCurrentLanguage, languages, setCountries } = useCountries();
  const { investor } = useSelector((state) => state);

  const setLanguage = async (value) => {
    try {
      await adminLocalizationApi.setLanguage({ languageId: value.key });

      const newLang = languages.find((i) => i.id === value.key)?.code?.toLowerCase();
      i18n.changeLanguage(newLang).then(() => {
        localStorage.setItem('language', newLang);
        queryClient.refetchQueries();
        setCountries()
          .then(() => {
            console.log('current lang and countries are changed');
          })
          .catch(() => {
            dispatch(entitiesActions.addToastInfo('Countries fetch error'));
          });
      });
    } catch (e) {
      dispatch(entitiesActions.addToastInfo('Change language error'));
    }
  };

  useEffect(() => {
    try {
      if (languages) {
        const currentLang = languages?.find((i) => i.code === i18n.language.toUpperCase());

        if (currentLang.id !== investor?.languageId) {
          setLanguage({ key: currentLang.id });
        }
      }
    } catch (e) {
      console.error(e);
    }
  }, [languages]);

  return (
    <div>
      {languages && (
        <Dropdown
          menu={{
            items: languages.map((item) => ({
              key: item.code,
              label: item.language,
              extra: i18n.language === item.code.toLowerCase() ? <CheckOutlined /> : null
            })),
            selectable: true,
            defaultSelectedKeys: languages.map((item) =>
              i18n.language === item.code.toLowerCase() ? item.code : null
            ),
            onClick: changeCurrentLanguage
          }}
          trigger={'click'}
        >
          <GlobalOutlined style={{ paddingLeft: 30 }} />
        </Dropdown>
      )}
    </div>
  );
};
